namespace $ { $mol_style_attach( "mol/date/demo/demo.view.css",
 "[mol_date_demo_formatted] {\n\tpadding: var(--mol_gap_text);\n}\n"
) }